module.exports = __webpack_public_path__ + "media/images/result_sets/circles/2n1n4n8n-3904c43327f92178d785d1d29baedb81.svg";